module.exports = __webpack_public_path__ + "img/9788901163673.6117cd8b.jpg";